module.exports = __webpack_public_path__ + "media/images/icons/inactive_exam-fb785274888125910d38f993854fd9b0.svg";